import { Injectable } from '@angular/core';

@Injectable()
export class PortalService {

  private KEY = 'ndsid';
  private KEY_HABILITA_SUPORTE = 'ndshabilitasuporte';

  constructor() { }

  setNumeroDeSerie(numero: String) {

    let obj = {
      numeroDeSerie: numero
    };

    try {
      localStorage.removeItem(this.KEY);
      localStorage.setItem(this.KEY, JSON.stringify(obj));

    } catch (e) {
      console.error('Erro ao gravar dados do numero de serie. Erro: ', e);
    }
  }

  getNumeroDeSerie(): String {
    //return this.numeroDeSerie;
    try {
      return JSON.parse(localStorage.getItem(this.KEY)).numeroDeSerie;
    } catch (e) {
      return null;
    }
  }

  setHabilitaSuporte(habilita: Boolean) {
    let obj = {
      habilita: habilita
    };

    try {
      localStorage.removeItem(this.KEY_HABILITA_SUPORTE);
      localStorage.setItem(this.KEY_HABILITA_SUPORTE, JSON.stringify(obj));

    } catch (e) {
      console.error('Erro ao gravar dados do habilita suporte. Erro: ', e);
    }
  }

  isHabilitaSuporte(): Boolean {
    try {
      return JSON.parse(localStorage.getItem(this.KEY_HABILITA_SUPORTE)).habilita;
    } catch (e) {
      console.error("Erro ao buscar habilita suporte. Erro: ", e);
      return null;
    }
  }
}


// WEBPACK FOOTER //
// C:/Disco D/Projetos/central-cliente/src/app/area-cliente/portal/portal.service.ts